import { EmspUserInvoiceBaseModel } from '@delmonicos/shared-sdk/libs/cpms/src/libs/invoices-service-lib/src/wrapper/outputs/emsp-user-invoice-base.model';
import { IdentifiedColumnDef } from '@tanstack/react-table';

import { EmspBoInvoiceListTypeCell } from './emsp-bo-invoice-list-type.cell';
import { EmspBoInvoiceListTypeHeader } from './emsp-bo-invoice-list-type.header';

export const EmspBoInvoiceListTypeColumn: IdentifiedColumnDef<
  EmspUserInvoiceBaseModel,
  EmspUserInvoiceBaseModel['type']
> = {
  enableSorting: false,
  header: EmspBoInvoiceListTypeHeader,
  cell: EmspBoInvoiceListTypeCell,
};
